import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { CsAgentAuthService } from "@spartacus/asm/root";
import { UserAccountFacade } from "@spartacus/user/account/root";
import { Subscription } from "rxjs";
import { MakeAPaymentService } from "src/app/make-a-payment/make-a-payment.service";
import { LoactionStripService } from "src/app/shared/modules/location-strip/loaction-strip.service";
import { SharedService } from "src/app/shared/services/shared.service";
import { CommonUtils } from "src/app/shared/utils/common.utils";
import { NumberTen } from "src/app/shared/utils/constants/global.constants";
import { OrderHistoryService } from '../../../order-history/order-history.service';


@Component({
  selector: 'app-order-list',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './order-list.component.html',
  styleUrls: ['./order-list.component.scss'],
})
export class OrderListComponent implements OnInit, OnDestroy {
  isLoadingDone = false;
  ordersList = [];
  userId;
  orderDataSub: Subscription;
  userAccSubs: Subscription;

  //ASM -eorders related
  isAsmUser: boolean = false;
  firewallExempt: boolean = false;
  isComServeAgent: boolean = false;
  isUserApprover: boolean = false;
  csAgentAuthSubscription: Subscription;
  orderFullResults: any;
  LocationListSub: Subscription;
  isLocationSelected: boolean;
  selectedLocations: any;
  locationFilter: {};

  constructor(
    private readonly service: OrderHistoryService,
    private readonly user: UserAccountFacade,
    private readonly cdr: ChangeDetectorRef,
    private readonly makeAPaymentService: MakeAPaymentService,
    private readonly csAgentAuthService: CsAgentAuthService,
    private readonly sharedService: SharedService,
    private readonly locStripService: LoactionStripService,
  ) { }

  ngOnInit(): void {
    //asm user check added
    this.csAgentAuthSubscription = this.csAgentAuthService.isCustomerEmulated().subscribe((res) => {
      this.isAsmUser = res ? res : false;
    });
    this.LocationListSub = this.locStripService.emitSelectedLocs.subscribe(locsData => {
      this.isLocationSelected = !!locsData?.length;
      this.selectedLocations = locsData;
    });
    this.isUserApprover = this.sharedService.getSessionStorage('approverOrDelegate');
    this.getOrderList();
  }

  getOrderList() {
    this.userAccSubs = this.user.get().subscribe((res) => {
      if (res) {
        this.userId = res;
        this.isUserApprover = this.userId?.approverOrDelegate ? this.userId?.approverOrDelegate : false;
        this.sharedService.setSessionStorage('approverOrDelegate', this.isUserApprover);
        if (this.isLocationSelected) {
          if (this.selectedLocations.length > 1) {
            this.locationFilter = '';
          }
          this.selectedLocations.forEach((loc) => {
            if (this.selectedLocations.length > 1) {
              this.locationFilter = (this.locationFilter === '') ? loc.accountNumber : this.locationFilter + ',' + loc.accountNumber;
            }
            else {
              this.locationFilter = loc.accountNumber;
            }
          })
        }
        const params = { baseSiteId: 'vsca', userId: this.userId.uid };
        let filters = {}
        if (this.selectedLocations && this.locationFilter != undefined && this.locationFilter != '') {
          filters = {
            currentPage: 0,
            pageSize: 10,
            selectedLocations: this.locationFilter
          };
        } else {
          filters = {
            currentPage: 0,
            pageSize: 10
          };
        }
        this.service.getOrderHistory(params, filters);
        this.orderDataSub = this.service.userData$.subscribe((result) => {
          if (result !== null) {
            this.orderFullResults = result;
            this.ordersList = result?.orders;
            if (result?.isComServeAgent) {
              this.isComServeAgent = result.isComServeAgent;
            }
            if (!!this.ordersList) {
              this.ordersList.forEach((element) => {
                const dateAndTime = element.placed.split('T');
                const uniquePackingSlips = element?.packingSlips?.length > 0 ? [...new Set(element?.packingSlips.map(data => data.slice(0, -6)))] : '';
                const uniqueTrackingNumbers = element?.tracking?.length > 0 ? [...new Set(element?.tracking)] : '';
                element.placedDateObj = dateAndTime[0];
                element.packingSlips = uniquePackingSlips;
                element.tracking = uniqueTrackingNumbers;
              });
              this.ordersList =
                !!this.ordersList && this.ordersList.length >= NumberTen
                  ? this.ordersList.slice(0, NumberTen)
                  : this.ordersList.slice();
            } else {
              this.ordersList = [];
            }
            this.isLoadingDone = true;
            this.cdr.detectChanges();
          }
        });
      }
    });
  }

  sortColumn(event, fieldName, dataList, type): any {
    CommonUtils.onSortClick(event, fieldName, dataList, type); // Column Sorting
  }

  ngOnDestroy() {
    this.orderDataSub?.unsubscribe();
    this.userAccSubs?.unsubscribe();
    this.csAgentAuthSubscription?.unsubscribe();
  }

  downloadInvoice(invoiceNo) {
    this.makeAPaymentService.downloadPdf(invoiceNo);
  }


  asmStringCheck(invoiceNumber) {
    let val = (/^\d+$/).test(invoiceNumber);
    return (!val || invoiceNumber.length >= 11 || invoiceNumber.length <= 7 || (this.isAsmUser && this.isComServeAgent));
  }
}